module.exports = __webpack_public_path__ + "static/img/001.ffb8e436.png";